module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAsUlEQVQ4jd3UMQrCQBCF4T9LsqWw29lIihQ5lKnENp2X0CtolYPYWHoAAymMjd0GbMRNYyMSNCi7IARfOTDfDFNMsN3tJbACpoDGLQ1QAIsQWGo1ytMkRsrISbG2VYfqmJvmchVA5oMASBmRJjHAXADaB+ligBbewkv+GAr7iuPJ7GPT+bR5q/12o76J3zK8Yw8TMta23sCj1wigKKsaH+xmLWVVA6yDzmPLAOVoPR/bHdgFMaopnGsvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dash-btn3.png
// module id = JCeM
// module chunks = 1